<template>
  <div>
    <VTextField
      :value="value"
      @input="$emit('input', $event)"
      :hide-details="hideDetails"
      :class="styles"
      v-bind="attrs"
      v-on="listeners"
      ref="input"
    />
  </div>
</template>

<script>
import flatten from 'lodash/flatten'

export default {
  name: 'AppFormText',
  inheritAttrs: false,
  data() {
    return {
      focused: false,
    }
  },
  computed: {
    value() {
      return this.$attrs.value
    },
    hideDetails() {
      return this.$attrs.hideDetails || true
    },
    styles() {
      return flatten(['pt-0', 'mt-0', this.$attrs.class])
    },
    attrs() {
      const { value, hideDetails, ...attrs } = this.$attrs
      delete attrs.class
      return attrs
    },
    listeners() {
      const { input, ...listeners } = this.$listeners
      return listeners
    },
    inputEl() {
      // VTextField の input 要素を取得
      return this.$refs.input.$refs.input
    },
  },
  mounted() {
    this.addListeners()
  },
  beforeDestroy() {
    this.removeListeners()
  },
  methods: {
    addListeners() {
      this.inputEl.addEventListener('focus', this.onFocus)
      this.inputEl.addEventListener('blur', this.onBlur)
      this.inputEl.focus()
    },
    removeListeners() {
      this.inputEl.removeEventListener('focus', this.onFocus)
      this.inputEl.removeEventListener('blur', this.onBlur)
    },
    onFocus() {
      this.focused = true
    },
    onBlur() {
      this.focused = false
    },
  },
}
</script>

<style scoped lang="scss"></style>
